export default __webpack_public_path__ + "static/training-wellbeing-6d953b93b72ee68d8a72f3f8f409b4b2.jpg";